import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

// The FDR offer's expiration is stored as the instant it becomes invalid —
// 12 AM PT on the day after the last eligible day (the buffer also lets Eastern
// users keep it until 3 AM ET). Everything user-facing shows that last eligible
// day, rendered in a fixed Pacific zone so ET and PT users see the same date.
const DISPLAY_TZ = "America/Los_Angeles";
export const DISPLAY_FORMAT = "MMM D, YYYY";

// Fallbacks are date-only display days, used only when the API omits the value.
export const FDR_EXPIRY_DATE_FALLBACK_AVAILABLE = "2026-08-14";
export const FDR_EXPIRY_DATE_FALLBACK_AVAILABLE_PHASE2 = "2026-10-06";

// Convert the cutoff instant to the last eligible calendar day in Pacific time.
// NOTE: do not use the UTC calendar date of the cutoff — that is the day after.
export const formatCutoffToLastEligibleDay = (
  isoDate: string
): string | undefined => {
  const cutoff = dayjs.utc(isoDate);
  return cutoff.isValid()
    ? cutoff.tz(DISPLAY_TZ).subtract(1, "millisecond").format(DISPLAY_FORMAT)
    : undefined;
};

// Fallback constants already represent the display day; format them directly.
export const formatFallbackDay = (dateOnly: string): string =>
  dayjs(dateOnly).format(DISPLAY_FORMAT);
